import { constants } from '../config';

const RECAPTCHA_URL = 'https://www.google.com/recaptcha/api.js';
const WINDOW_READY_CALLBACK_NAME = 'recaptchaReadyFunction';
const WINDOW_SUCCESS_CALLBACK_NAME = 'recaptchaSuccessFunction';
const WINDOW_ERROR_CALLBACK_NAME = 'recaptchaErrorFunction';
const WINDOW_EXPIRY_CALLBACK_NAME = 'recaptchaExpiryFunction';

/*
  This class handles recaptchas.
*/
class Recaptcha {
  constructor() {
    this.id = null;
    this.key = constants.recaptchaKey;
    this.ready = false;
    this.readyCallbacks = [];
    this.successCallbacks = [];
    this.expiryCallbacks = [];
    this.errorCallbacks = [];
    this._handleLoad = this._handleLoad.bind(this);
    this._runErrorCallbacks = this._runErrorCallbacks.bind(this);
    this._runSuccessCallbacks = this._runSuccessCallbacks.bind(this);
    this._runExpiryCallbacks = this._runExpiryCallbacks.bind(this);
    // Create recaptcha script
    const head = document.getElementsByTagName('head').item(0);
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', `${RECAPTCHA_URL}?render=explicit&hl=es&onload=${WINDOW_READY_CALLBACK_NAME}`);
    head.appendChild(script);
    // Set callbacks on window
    window[WINDOW_READY_CALLBACK_NAME] = this._handleLoad;
    window[WINDOW_SUCCESS_CALLBACK_NAME] = this._runSuccessCallbacks;
    window[WINDOW_ERROR_CALLBACK_NAME] = this._runErrorCallbacks;
    window[WINDOW_EXPIRY_CALLBACK_NAME] = this._runExpiryCallbacks;
  }

  _handleLoad() {
    // Remove from window
    delete window[WINDOW_READY_CALLBACK_NAME];
    this.ready = true;
    this.readyCallbacks.forEach(callback => callback());
    this.readyCallbacks = [];
  }

  _runErrorCallbacks() {
    this.errorCallbacks.forEach(callback => callback());
  }

  _runSuccessCallbacks(token) {
    this.successCallbacks.forEach(callback => callback(token));
  }

  _runExpiryCallbacks() {
    this.expiryCallbacks.forEach(callback => callback());
  }

  render(elementId) {
    this.id = window.grecaptcha.render(elementId, {
      sitekey: this.key,
      callback: WINDOW_SUCCESS_CALLBACK_NAME,
      'expired-callback': WINDOW_EXPIRY_CALLBACK_NAME,
      'error-callback': WINDOW_ERROR_CALLBACK_NAME,
    });
  }

  onReady(callback) {
    if (!this.ready) {
      this.readyCallbacks.push(callback);
    } else {
      callback();
    }
  }

  onError(callback) {
    this.errorCallbacks.push(callback);
  }

  offError(callback) {
    this.errorCallbacks = this.errorCallbacks.filter(c => callback !== c);
  }

  onSuccess(callback) {
    this.successCallbacks.push(callback);
  }

  offSuccess(callback) {
    this.successCallbacks = this.successCallbacks.filter(c => callback !== c);
  }

  onExpiry(callback) {
    this.expiryCallbacks.push(callback);
  }

  offExpiry(callback) {
    this.expiryCallbacks = this.expiryCallbacks.filter(c => callback !== c);
  }

  reset() {
    window.grecaptcha.reset(this.id);
  }
}

const recaptcha = new Recaptcha();

export { recaptcha as Recaptcha };



// WEBPACK FOOTER //
// ./src/helpers/Recaptcha.js